import React from 'react';
import Modal from './Modal';
import PrimaryButton from './PrimaryButton';
import { useLang } from '../context/LangContext';

interface AuctionEndedModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm?: () => void; // 확인 버튼 클릭 시 추가 동작
}

// 국제화 텍스트
const auctionEndedTexts = {
  ko: {
    header: '경매의 모든 아이템 입찰이 종료되었습니다',
    body: '모든 경매 아이템의 입찰이 완료되었습니다.\n메인 페이지로 이동합니다.',
    confirmButton: '메인으로'
  },
  en: {
    header: 'All auction items bidding has ended',
    body: 'Bidding for all auction items has been completed.\nRedirecting to main page.',
    confirmButton: 'Go Home'
  }
};

const AuctionEndedModal: React.FC<AuctionEndedModalProps> = ({ 
  isOpen, 
  onClose, 
  onConfirm 
}) => {
  const { lang } = useLang();
  const texts = auctionEndedTexts[lang];

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    } else {
      onClose();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      header={texts.header}
      bgColor="white"
      body={texts.body}
      footer={
        <PrimaryButton onClick={handleConfirm}>
          {texts.confirmButton}
        </PrimaryButton>
      }
    />
  );
};

export default AuctionEndedModal;